import * as actionTypes from '../actionTypes/application';

export default {
  setApplications: (params) => (dispatch) => {
    const actionData = { type: actionTypes.SET_APPLICATIONS, payload: params };
    dispatch(actionData);
  },
  setApplication: (params) => (dispatch) => {
    const actionData = { type: actionTypes.SET_APPLICATION, payload: params };
    dispatch(actionData);
  },
  updateApplication: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_APPLICATIONS,
      payload: params,
    };
    dispatch(actionData);
  },
  updateApplicationOnMove: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_APPLICATION_ON_MOVE,
      payload: params,
    };
    dispatch(actionData);
  },
  setBtnLoader: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.SET_BTN_LOADER,
      payload: params,
    };
    dispatch(actionData);
  },
  addApplication: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.ADD_APPLICATION,
      payload: params,
    };
    dispatch(actionData);
  },
  updateAssignee: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_ASSIGNEE,
      payload: params,
    };
    dispatch(actionData);
  },
  setUnseenCount: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.SET_UNSEEN_COUNT,
      payload: params,
    };
    dispatch(actionData);
  },
  updateAppLogbook: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_APP_LOGBOOK,
      payload: params,
    };
    dispatch(actionData);
  },
  addReviewToApp: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.ADD_REVIEW_TO_APP,
      payload: params,
    };
    dispatch(actionData);
  },
  setAllMembers: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.ALL_MEMBERS,
      payload: params,
    };
    dispatch(actionData);
  },
  setCurrentAssignee: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.CURRENT_ASSIGNEE,
      payload: params,
    };
    dispatch(actionData);
  },
  setResStatus: ({ partitionKey, status, keyName }) => ({
    type: actionTypes.SET_LOGBOOK_COMMENT_RES,
    payload: {
      partitionKey,
      status,
      keyName,
    },
  }),
  setSnackBarStateForTaskBoard: ({
    showSnackBar,
    snackBarType,
    snackBarMessage,
  }) => ({
    type: actionTypes.SET_SNACKBAR_STATE_FOR_TASK_BOARD,
    payload: {
      showSnackBar,
      snackBarType,
      snackBarMessage,
    },
  }),
};
